import { Button } from "@/components/ui/button";
import { ArrowRight, CheckCircle2, Clock, MessageCircle, Check } from "lucide-react";
import { Footer } from "@/components/layout/Footer";
import { Link } from "react-router-dom";

export default function KiwifyPage() {
  const features = [
    "eBook completo com prompts de IA para advogados",
    "Modelos prontos para ChatGPT em várias áreas do Direito",
    "Suporte via WhatsApp (seg. a sáb. das 9h às 16h)",
    "Sumário clicável para navegação fácil",
    "Atualizações futuras incluídas",
    "Garantia de satisfação de 7 dias"
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-grow bg-gradient-to-b from-white to-gray-50">
        <div className="container mx-auto px-4 py-8">
          <div className="max-w-4xl mx-auto">
            <Link to="https://lexprompt.decidedigital.com.br/" className="flex items-center justify-center mb-12">
              <span className="text-lawyer-primary font-display font-bold text-5xl dark:text-white">
                Lex<span className="text-lawyer-secondary">Prompt</span>
              </span>
            </Link>
            <img
              src="/copy.webp"
              alt="Capa do eBook Prompts Jurídicos para Advogados"
              className="mx-auto mb-0 w-full max-w-xs md:max-w-xs lg:max-w-sm drop-shadow-xl rounded-lg"
            />
          </div>
        </div>

        <div className="container mx-auto px-4 py-8">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              eBook de Prompts de IA para Advogados
            </h1>
            <p className="text-xl text-gray-600 mb-12">
              Impulsione sua advocacia com prompts de IA otimizados e modelos prontos para ChatGPT
            </p>

            <div className="max-w-lg mx-auto mb-12">
              <div className="bg-white rounded-xl shadow-lg overflow-hidden transform transition-all hover:scale-105 border-2 border-lawyer-secondary">
                <div className="bg-lawyer-secondary text-white text-center py-2 text-sm font-medium">
                  Oferta Especial
                </div>
                <div className="p-8 text-center border-b border-gray-100 flex flex-col justify-between">
                  <img
                    src="/selo-kiwify.webp"
                    alt="Compra Garantida Kiwify"
                    className="mx-auto mb-0 w-full max-w-[200px] lg:max-w-[140px]"
                  />
                 <div className="flex-1 text-center">
                   <h3 className="text-lawyer-primary font-semibold text-xl mb-2">eBook Completo</h3>
                    <div className="flex items-center justify-center">
                      <span className="text-5xl font-bold text-lawyer-primary">R$ 19,99</span>
                    </div>
                    <p className="text-gray-600 mt-2">Investimento único</p>
                  </div>
                </div>
                <div className="p-8">
                  <ul className="space-y-4 mb-8">
                    {features.map((feature, idx) => (
                      <li key={idx} className="flex items-start  justify-start text-left">
                        <Check className="h-5 w-5 text-lawyer-secondary mr-3 flex-shrink-0" />
                        <span className="text-gray-600">{feature}</span>
                      </li>
                    ))}
                  </ul>
                  <Button
                    size="lg"
                    className="w-full p-6 flex items-center justify-center gap-2 bg-[#072a45] hover:bg-[#072a45] dark:bg-[#d4af37] dark:hover:bg-[#d4af37] text-white dark:text-[#072a45]"
                    onClick={() => window.location.href = "https://pay.kiwify.com.br/C6pGxQb"}
                  >
                    Comprar Agora
                    <ArrowRight className="ml-2 w-5 h-5" />
                  </Button>

                   <img
                    src="/ssl.png"
                    alt="Capa do eBook Prompts Jurídicos para Advogados"
                    className="mx-auto mb-0 w-full  max-w-[150px] mt-5  rounded-lg"
                  />
                </div>
              </div>
            </div>

            <div className="grid md:grid-cols-3 gap-8 mb-12">
              <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
                <div className="w-12 h-12 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-4">
                  <CheckCircle2 className="w-6 h-6 text-blue-600" />
                </div>
                <h3 className="font-semibold text-lg mb-2">Modelos Prontos</h3>
                <p className="text-gray-600">Prompts otimizados para diversas áreas do Direito</p>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
                <div className="w-12 h-12 bg-green-50 rounded-full flex items-center justify-center mx-auto mb-4">
                  <MessageCircle className="w-6 h-6 text-green-600" />
                </div>
                <h3 className="font-semibold text-lg mb-2">Suporte WhatsApp</h3>
                <p className="text-gray-600">Atendimento de seg. a sáb. das 9h às 16h</p>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
                <div className="w-12 h-12 bg-purple-50 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Clock className="w-6 h-6 text-purple-600" />
                </div>
                <h3 className="font-semibold text-lg mb-2">Navegação Fácil</h3>
                <p className="text-gray-600">Sumário clicável para acesso rápido ao conteúdo</p>
              </div>
            </div>

            <div className="mt-16 text-center">
              <h3 className="text-xl font-bold mb-3">Perguntas Frequentes</h3>
              <div className="max-w-3xl mx-auto mt-8 space-y-6 text-left">
                <div className="p-5 border border-gray-200 rounded-lg bg-white">
                  <h4 className="font-medium text-lg mb-2">Como receberei o material?</h4>
                  <p className="text-gray-600">Após a confirmação do pagamento, você receberá um e-mail com o link para download do eBook em formato PDF.</p>
                </div>
                <div className="p-5 border border-gray-200 rounded-lg bg-white">
                  <h4 className="font-medium text-lg mb-2">Posso solicitar reembolso?</h4>
                  <p className="text-gray-600">Sim, oferecemos garantia de satisfação de 7 dias. Se você não ficar satisfeito com o material, devolvemos 100% do seu dinheiro.</p>
                </div>
                <div className="p-5 border border-gray-200 rounded-lg bg-white">
                  <h4 className="font-medium text-lg mb-2">O material é atualizado?</h4>
                  <p className="text-gray-600">Sim, você receberá todas as atualizações futuras do material sem custo adicional.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
} 